import React from 'react'
import moment from 'moment'
import { DATE_TIME_FORMAT } from 'constants/app'

/**
 * General information section
 * @param {string} boatName - Name of the vessel
 * @param {string} dockLabel - Dock/berth label
 * @param {string} analysisDate - Date of the analysis
 */
export const GeneralInfo = ({ boatName, dockLabel, analysisDate }) => {
    return (
        <>
            <h2>Informations générales / General information :</h2>
            <ul>
                <li>
                    Nom du navire / Vessel name : <b>{boatName}</b>
                </li>
                <li>
                    Quai / Berth : <b>{dockLabel}</b>
                </li>
                <li>
                    Date de l'analyse<sup>1</sup> / Analysis date<sup>1</sup> :{' '}
                    <b>{moment(analysisDate).format(DATE_TIME_FORMAT)}</b>
                </li>
            </ul>
        </>
    )
}
